import React, { useState, useEffect } from "react";
import Theme from "../../../styles/Theme/Theme";
import { Text } from "./Text";
import CustomIcon from "../Icons/CustomIcon";
import { WidgetCard } from "../../../styles/global/Widget.styled";
import { Weather } from "./Weather";
import { Fluctuation } from "./Fluctuation";
import { RenderChart } from "./RenderChart";
import { Row, Col, Switch, Flex, Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { HeatmapComponent } from "../Molecules/Maps/HeatmapComponent";
import { MapsComponent } from "../Molecules/Maps/MapsComponent";

export const Widget = ({ data, filters, yearsToFetch, municipalitiesToFetch, fetchIsLoading, idToFetch, energyType, onButtonClick, coordinates }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showEventsNA, setShowEventsNA] = useState(false);
  const [chartTypeAtivo, setChartTypeAtivo] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    // Update the current date every second (or at the desired interval)
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 3600000);


    if (data.buttons) {
      let isBtnSelected = [];
      data?.buttons.map((element, index) => {
        if (index == 0) {
          isBtnSelected.push(true);
        } else {
          isBtnSelected.push(false);
        }
      });
      setIsSelected(isBtnSelected);
    }
    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  // Options for formatting the date
  const options = { weekday: "long", month: "long" };
  const getLanguage = (lang) => {
    switch (lang) {
      case 'pt':
        return 'pt-PT';

      default:
        return 'en-GB'
    }
  }
  // Convert the date to a string format, e.g., "October 9, 2023"
  // Extract day, month, and year
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString(getLanguage(i18next.resolvedLanguage), { month: "short" });
  const formattedDate = `${day} ${month}`;
  const formattedWeekday = currentDate.toLocaleDateString(getLanguage(i18next.resolvedLanguage), {
    weekday: "short",
  });

  const onChangeSwitch = (checked) => {
    setShowEventsNA(checked);
  };
  const [isSelected, setIsSelected] = useState([]);

  const selectedChart = (index) => {
    setIsSelected(isSelected.map((v, i) => {
      if (index === i) {
        return true;
      }
      return false;
    }))

  }
  let map;
  switch (data?.map?.type) {
    case 'heatmap':
      map = <HeatmapComponent mapId={'e1816747e3cd86e6'} idQuery={data?.map?.idQuery} tenant={municipalitiesToFetch} coordinates={coordinates} />
      break;
    default:
      map = <MapsComponent mapId={data?.map} />
  }

  return (
    <WidgetCard
      $height={data?.height}
      $width={data?.width}
      $backgroundColor={data?.background}
      $border={data?.border}
      $justifyContent={data?.justify}
      $flexDirection={data?.direction}
    >
      {data?.showWeather ? <Weather /> : null}

      <div className="widget-header">

        <div className="widget-title">
          <CustomIcon
            icon={data?.icon}
            iconsize="sm"
            color={data?.iconColor ?? "teal-4"}
            bgColor={
              !data?.icon && data?.iconColor
                ? data?.iconColor
                : null
            }
          />
          {data?.title ?
            <Text
              $fontColor={
                data?.titlColor ? data?.titlColor : "coolgray-12"
              }
              $marginLeft="s03"
              $fontSize="text_md"
              $weight="medium"
            >
              {t(data?.title)}
            </Text>
            : null}
        </div>

        {data?.buttons ? (
          <Flex gap='small'>
            {data.buttons.map((button, index) => (
              <Button className={(
                isSelected[index] ? "ant-btn-black" : "ant-btn-outline") + " -xsmall"}
                key={button?.key ?? index}
                title={button?.title}
                onClick={() => onButtonClick(button.chartType, button.chartId, button?.key, selectedChart(index))}
              > {button?.title} </Button>

            ))}
          </Flex>
        ) : null}

        {data?.switch ? (
          <div className="widget-actions">
            <Flex gap="middle" align="start" horizontal>
              <Switch onChange={onChangeSwitch} />
              <span>{t(data?.switch)}</span>
            </Flex>
          </div>
        ) : null}
        {data?.tooltip ? (
          <Tooltip className="widget-tooltip" title={data?.tooltip} color={Theme.color.white} colorText={Theme.color["coolgray-12"]}>
            <Button
              shape="circle"
              type='text'
              icon={<CustomIcon icon={'Information'} iconsize='md' color='blue-4' />}
            />
          </Tooltip>
        ) : null}
        {data?.showDate ? (
          <div className="widget-date">
            <Text $fontSize="text_sm" $fontColor="white" $weight="semibold">
              {formattedWeekday}
            </Text>
            &nbsp;
            <Text $fontSize="text_sm" $fontColor="white" $weight="light">
              {formattedDate}
            </Text>
          </div>
        ) : null}

      </div>
      {data?.description ? (
        <Text
          $fontColor="coolgray-12"
          $marginLeft="s10"
          $fontSize="text_sm"
          $weight="regular"
        >
          {t(data?.description)}
        </Text>) : null
      }

      <div className="widget-content full-height">
        {data?.charts ? (
          <Row gutter={16} className="full-height">
            {data?.charts.map((el, index) => (
              el.hidden ?
                <Col
                  key={index}
                  span={el.cols ?? 24}
                  className={
                    data?.charts.length == 1 || data?.hasHiddenCharts ? el?.hidden ? 'hidden' : "full-height chart" : "chart"
                  }
                >
                  {/* <Text $fontSize="text_sm" $fontColor="coolgray-12">
                    {el?.title}
                  </Text> */}
                  <div className={el?.hidden ? 'hidden' : ''}>
                    <RenderChart
                      key={index}
                      chartdata={el?.data}
                      charttype={el?.chartType}
                      chartquery={el?.chartQuery}
                      idQuery={el.idQuery}
                      width={el?.width ?? '100%'}
                      chartId={el?.chartId}
                      yearsToFetch={yearsToFetch}
                      municipalitiesToFetch={municipalitiesToFetch}
                      fetchIsLoading={fetchIsLoading}
                      idToFetch={idToFetch}
                      energyType={energyType}
                      filters={filters}
                      language={i18next.resolvedLanguage}
                      title={el?.title}
                    />
                  </div>

                </Col>
                :
                <Col
                  key={index}
                  span={el.cols ?? 24
                  }
                  className={
                    data?.charts.length == 1 ? "full-height chart" : "chart"
                  }
                >
                  {/* <Row gutter={16} vertical="true">
                    <Col span={12}>
                      <Text $fontSize="text_sm" $fontColor="coolgray-12">
                        {el?.title}
                      </Text>
                    </Col>
                    <Col span={12}> */}
                  <RenderChart
                    key={index}
                    chartdata={el?.data}
                    charttype={el?.chartType}
                    chartquery={el?.chartQuery}
                    idQuery={el.idQuery}
                    width={el?.width ?? '100%'}
                    height={el?.height ?? null}
                    chartId={el?.chartId}
                    yearsToFetch={yearsToFetch}
                    municipalitiesToFetch={municipalitiesToFetch}
                    fetchIsLoading={fetchIsLoading}
                    idToFetch={idToFetch}
                    energyType={energyType}
                    filters={filters}
                    language={i18next.resolvedLanguage}
                    title={el?.title}
                  />
                  {/* </Col>

                  </Row> */}

                </Col>

            ))}
          </Row>
        ) : null}

        {data?.fluctuation ? <Fluctuation /> : null}

        {data?.map ? (
          <Row gutter={16} className="full-height">
            <Col span={24}>
              {map}
            </Col>
          </Row>
        ) : null}
      </div>

    </WidgetCard >
  );
};

const DUMMY_DATA = {
  header: [{ icon: "Lamp", title: "Hover tooltip" }],
  iconText: [
    { icon: "Calendar", text: "04-02-2022" },
    { icon: null, text: "Descrição breve" },
  ],
};
